import { createSlice } from '@reduxjs/toolkit'
import { WELCOME_MESSAGE_SHOWN_KEY } from 'constants/system.constant'

const initialState = {
    data: null,
    loading: false,
    error: null,
}

export const systemConfigSlice = createSlice({
    name: 'systemConfig',
    initialState,
    reducers: {
        setSystemConfig: (state, action) => {
            state.data = action.payload
            state.loading = false
            state.error = null
        },
        setSystemConfigLoading: (state, action) => {
            state.loading = action.payload
        },
        setSystemConfigError: (state, action) => {
            state.error = action.payload
            state.loading = false
        },
        clearSystemConfig: (state) => {
            state.data = null
            state.loading = false
            state.error = null
            sessionStorage.removeItem(WELCOME_MESSAGE_SHOWN_KEY)
        },
    },
})

export const { 
    setSystemConfig, 
    setSystemConfigLoading,
    setSystemConfigError,
    clearSystemConfig 
} = systemConfigSlice.actions

export default systemConfigSlice.reducer
